import React, { useEffect, useRef, useState } from "react";
import { useFlashlight } from "./FlashLightProvider";
import "./FlashLightSection.css";

export default function FlashlightSection({
  backgroundColor = "white",
  curtainColor = "rgba(0, 0, 0)",
  backgroundChildren,
  foregroundChildren,
  radius, // optional per-section override
  cursor = 'none'
}) {
  const { position, radius: globalRadius } = useFlashlight();
  const sectionRef = useRef(null);
  const [percentPos, setPercentPos] = useState({ x: 10, y: 20 });

  useEffect(() => {
    if (!sectionRef.current) return;

    const rect = sectionRef.current.getBoundingClientRect();
    const x = ((position.x - rect.left) / rect.width) * 100;
    const y = ((position.y - rect.top) / rect.height) * 100;

    setPercentPos({ x, y });
  }, [position]);

  const effectiveRadius = radius || globalRadius;

  return (
    <section
      ref={sectionRef}
      className="flashlight-section"
      style={{
        "--x": `${percentPos.x}%`,
        "--y": `${percentPos.y}%`,
        "--r": `${effectiveRadius}px`,
        "--curtain-color": curtainColor,
        "--background-color": backgroundColor,
        "--cursor": cursor
      }}
    >
      <div className="background">{backgroundChildren}</div>
      <div className="curtain"></div>
      <div className="foreground">{foregroundChildren}</div>
    </section>
  );
}
 